import './Layout.scss';

import { Loader, TopNavigation } from '@trackman/web-shared-components';
import { Can, Cannot } from 'components/Can';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { AppPermissions } from 'constants/AppPermissions';
import AppSwitcher from 'components/AppSwitcher/AppSwitcher';
import { DefaultRoutes } from 'Routes';
import Forbidden from 'pages/Forbidden/Forbidden';
import LoggedOutInfoModal from 'components/LoggedOutInfoModal/LoggedOutInfoModal';
import { Notifications } from 'components/Notifications';
import ProfileIconMenu from 'components/ProfileIconMenu/ProfileIconMenu';
import { observer } from 'mobx-react-lite';
import { useStores } from 'index';

type Props = {
  children: React.ReactNode;
};

const Layout = observer(({ children }: Props) => {
  const ss = useStores().startupStore;
  const history = useHistory();

  const [displayContent, setDisplayContent] = useState(false);

  useEffect(() => {
    if (ss.hasBearerToken) setDisplayContent(true);
  }, [ss.hasBearerToken]);

  return (
    <div className='layout-content-container'>
      <div className='top-navigation'>
        <TopNavigation
          appName={'Tagging App Dispatcher'}
          appSport='Softball'
          navigation={[]}
          activeNavigationLabel={''}
          utilities={
            ss.hasBearerToken && !ss.isInitializing
              ? [
                  { key: 'profile-icon-menu', component: <ProfileIconMenu setDisplayContent={setDisplayContent} /> },
                  {
                    key: 'app-switcher-icon-menu',
                    component: <AppSwitcher setDisplayContent={setDisplayContent} />,
                  },
                ]
              : []
          }
          animated
          displayContent={displayContent}
          onLogoClick={() => history.push(DefaultRoutes.FrontPage)}
        />
      </div>
      {!displayContent && (
        <div className='spinner'>
          <Loader size='large' />
        </div>
      )}
      <div
        style={{
          opacity: displayContent ? 1 : 0,
          transition: 'opacity 0.3s',
          pointerEvents: displayContent ? 'auto' : 'none',
          paddingBottom: '76px',
        }}
        className='container'
      >
        {ss.hasBearerToken && (
          <>
            <Notifications />
            <Can need={AppPermissions.PortalAccess}>{children}</Can>
            <Cannot need={AppPermissions.PortalAccess}>
              <Forbidden />
            </Cannot>
          </>
        )}
      </div>
      {ss.config && <LoggedOutInfoModal logoutUrl={ss.config.logoutUrl} />}
    </div>
  );
});

export default Layout;
